<template>
  <ul class="Pagination" :class="PaginationClass">
    <li class="page-item prev-page" :class="{'disabled': currentPage === 1, 'no-arrows': noArrows}">
      <a class="page-link" aria-label="Previous" @click="prevPage">
        <i class="fas fa-angle-double-left"></i>
      </a>
    </li>
    <li class="page-item"
        v-for="item in range(minPage, maxPage)"
        :key="item"
        :class="{active: currentPage === item}">
      <a class="page-link" @click="changePage(item)">{{item}}</a>
    </li>
    <li class="page-item page-pre next-page" :class="{ 'disabled': currentPage === totalPages, 'no-arrows': noArrows}">
      <a class="page-link" aria-label="Next" @click="nextPage">
        <i class="fas fa-angle-double-right"></i>
      </a>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      type: {
        type: String,
        default: 'primary',
        validator: (value) => {
          return ['default', 'primary', 'danger', 'success', 'warning', 'info', 'rose'].includes(value)
        }
      },
      noArrows: Boolean,
      pageCount: {
        type: Number,
        default: 0
      },
      currentPage: {
        type: Number,
        default: 0
      },
      totalPage: {
        type: Number,
        default: 0
      }
    },
    computed: {
      PaginationClass () {
        return `Pagination-${this.type}`
      },
      totalPages () {
        return this.totalPage
      },
      pagesToDisplay () {
        if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
          return this.totalPages
        }
        return this.defaultPagesToDisplay
      },
      minPage () {
        if (this.currentPage >= this.pagesToDisplay) {
          const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
          const newMaxPage = pagesToAdd + this.currentPage
          if (newMaxPage > this.totalPages) {
            return this.totalPages - this.pagesToDisplay + 1
          }
          return this.currentPage - pagesToAdd
        } else {
          return 1
        }
      },
      maxPage () {
        if (this.currentPage >= this.pagesToDisplay) {
          const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
          const newMaxPage = pagesToAdd + this.currentPage
          if (newMaxPage < this.totalPages) {
            return newMaxPage
          } else {
            return this.totalPages
          }
        } else {
          return this.pagesToDisplay
        }
      }
    },
    data () {
      return {
        defaultPagesToDisplay: 5
      }
    },
    methods: {
      range (min, max) {
        let arr = []
        for (let i = min; i <= max; i++) {
          arr.push(i)
        }
        return arr
      },
      changePage (item) {
        this.$emit('get', item)
      },
      nextPage () {
        if (this.currentPage < this.totalPages) {
          this.$emit('get', this.currentPage + 1)
        }
      },
      prevPage () {
        if (this.currentPage > 1) {
          this.$emit('get', this.currentPage - 1)
        }
      }
    }
  }
</script>
